// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeInfo_root__xsQ6_"};